module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_5.9ae38947.png";